class CookieHandler {
    static findBulkParam(param) {
      let utm_param = '';
      window.cookies.forEach((item) => {
        if (item.indexOf('_shopify_sa_p') !== -1) {
          let utm_body = item.split('=')[1];

          if(utm_body && utm_body.includes('%')) {

          let utm_params = utm_body.split('%');
  
            const utmObjects = utm_params.reduce((arr, val, index, sourceArray) => {
              if (index % 2 === 0) {
                const key = val.replace(/^26/, '');
                const value = sourceArray[index + 1].replace(/^3D/, '');
                arr.push({ [key]: value });
              }
              return arr;
            }, []);
    
            const utmTermValue = utmObjects.find((obj) => obj.hasOwnProperty(param));
            utm_param = utmTermValue[param];

          }
        }
      });
  
      return utm_param;
    }

    static findMetafieldsDiscount(discount_codes, param) {
        let discount = false;

        for(let key in discount_codes) {
            if (discount_codes[key] == param) {
                discount = discount_codes[key];
                break;
            }
        }

        return discount;
    }
  
    static findUTMParam(param) {
      let utmParam = '';
      window.cookies.forEach((item) => {
        if (item.includes(param)) {
          utmParam = item.split('=')[1];
        }
      });
      return utmParam;
    }
  
    static isURLDiscount() {
      let discount = false;
      const queryString = window.location.search;
  
      if (!queryString) {
        return discount;
      }
  
      const urlParams = new URLSearchParams(queryString);
      const queryDiscount = urlParams.get('discount');
  
      if (queryDiscount) {
        discount = true;
      }
  
      return discount;
    }
  
    static applyURLDiscount(discount) {
      let divider = location.href.includes('?') ? '&' : '/?';
      location.href = `${location.href}${divider}discount=${discount}`;
    }

    static findDiscount(discountCodes) {
        return new Promise((resolve) => {
          let waitCookies = setInterval(() => {
            if (window.cookies) {
              clearInterval(waitCookies);
    
              const utm_term = CookieHandler.findUTMParam('__attentive_utm_param_term');
              const bulk_param = CookieHandler.findBulkParam('utm_term');
    
              let cookie;
              let metafields_discount = false;
    
              if (utm_term) {
                cookie = utm_term;
              } else {
                cookie = bulk_param;
              }
    
              if (!!discountCodes && !!Object.keys(discountCodes).length) {
                metafields_discount = CookieHandler.findMetafieldsDiscount(discountCodes, cookie);
              }

              let discount = metafields_discount || false;
    
              resolve(discount);
            }
          });
        });
      }
}
  